/** The small room fields needed to decide whether a client has the right song. */
export type ClassroomRoomSongState = {
  code: string;
  musicalPieceId?: string;
};

/** The small selected-song fields shared by the lobby and game views. */
export type ClassroomSelectedSongState = {
  musicalPieceId: string;
};

type ClassroomSongHydrationInput = {
  room: ClassroomRoomSongState | null | undefined;
  roomCode: string;
  selectedSong: ClassroomSelectedSongState | null | undefined;
  isConnected: boolean;
};

/**
 * The room is the shared authority. A client must not load a cached song unless
 * it is the exact piece currently selected for that room.
 */
export function needsClassroomSongHydration({
  room,
  roomCode,
  selectedSong,
  isConnected,
}: ClassroomSongHydrationInput): boolean {
  return (
    !room ||
    room.code !== roomCode ||
    !room.musicalPieceId ||
    !selectedSong ||
    selectedSong.musicalPieceId !== room.musicalPieceId ||
    !isConnected
  );
}

type ClassroomStartInput = {
  room: ClassroomRoomSongState | null | undefined;
  selectedSong: ClassroomSelectedSongState | null | undefined;
  pendingMusicalPieceId: string | null;
};

/** Start only when the selected song has caught up with the persisted room pick. */
export function canStartClassroomSession({
  room,
  selectedSong,
  pendingMusicalPieceId,
}: ClassroomStartInput): boolean {
  return (
    pendingMusicalPieceId === null &&
    Boolean(room?.musicalPieceId) &&
    selectedSong?.musicalPieceId === room?.musicalPieceId
  );
}
